import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'snakeToTitle',
  standalone: true
})
export class SnakeToTitlePipe implements PipeTransform {
  transform(value: string): string {
    if (!value) return '';
    
    // Split by underscore and convert each word to title case
    return value
      .split('_')
      .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(' ');
  }
} 